<template>
  <component :is="to ? 'router-link' : 'div'" :to="to" class="dashboard-card">
    <div class="dashboard-card__icon">
      <slot name="icon">
        <b-icon-bar-chart-line />
      </slot>
    </div>
    <div class="dashboard-card__content">
      <span class="dashboard-card__label">{{ title }}</span>
      <div v-if="loading" class="dashboard-card__value">
        <b-spinner small class="dashboard-card__spinner" />
      </div>
      <strong
        v-else
        :class="['dashboard-card__value', { 'dashboard-card__value--success': success }]"
      >
        {{ value }}
      </strong>
    </div>
  </component>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "R$ 0,00",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [String, Object],
      default: "",
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  min-height: 96px;
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 22px 24px;
  border: 1px solid rgba(71, 48, 134, 0.06);
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 18px 40px rgba(31, 28, 92, 0.06);
  text-decoration: none;
  color: #100f53;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.dashboard-card:hover {
  color: #100f53;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 22px 46px rgba(31, 28, 92, 0.1);
}

.dashboard-card__icon {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  font-size: 24px;
  background: linear-gradient(145deg, #6d31ff 0%, #1b0876 100%);
  box-shadow: 0 12px 22px rgba(89, 43, 215, 0.22);
}

.dashboard-card__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dashboard-card__label {
  color: #696694;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 500;
}

.dashboard-card__value {
  color: #110d57;
  font-size: 17px;
  line-height: 1.2;
  font-weight: 800;
}

.dashboard-card__value--success {
  color: #0a9b31;
}

.dashboard-card__spinner {
  color: #5d35d9;
}

@media screen and (max-width: 700px) {
  .dashboard-card {
    min-height: 86px;
    padding: 18px;
  }
}
</style>
